import { render } from "./ToTopLink.vue?vue&type=template&id=8f0bd9ea"
import script from "./ToTopLink.vue?vue&type=script&lang=js"
export * from "./ToTopLink.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__